var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line",class:{active: _vm.hasMounted}},_vm._l((_vm.realSlices),function(slice,index){return _c('div',{key:index,staticClass:"line-slice",class:slice.name,style:({ width: slice.width})})}))}
var staticRenderFns = []

export { render, staticRenderFns }